import * as React from 'react'

import { cn } from '../cn'

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
  ({ className, type, onWheel, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
          // Number fields are keyboard-only: strip the native up/down spinner
          // (WebKit pseudo-elements + Firefox). Pseudo-elements only exist on
          // type=number, so this is a no-op for other input types.
          '[appearance:textfield] [&::-webkit-inner-spin-button]:m-0 [&::-webkit-inner-spin-button]:[-webkit-appearance:none] [&::-webkit-outer-spin-button]:m-0 [&::-webkit-outer-spin-button]:[-webkit-appearance:none]',
          className,
        )}
        ref={ref}
        onWheel={(e) => {
          // For number inputs, blur on wheel to prevent accidental value changes on scroll.
          if (type === 'number') {
            ;(e.target as HTMLInputElement).blur()
          }
          onWheel?.(e)
        }}
        {...props}
      />
    )
  },
)
Input.displayName = 'Input'

export { Input }
